(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup-slide"] && !Shopify.designMode) return;
  try {
    
// sections/popup-slide.liquid
function setCookie(name, value, days) {
	if (days > 0) {
		const expiryDate = new Date();
		expiryDate.setTime(expiryDate.getTime() + 86400000 * days);
		const expires = '; expires=' + expiryDate.toUTCString();
		document.cookie = name + '=' + (value || '') + expires + '; path=/; SameSite=Lax';
	}
}

function getCookie(name) {
	const prefix = name + '=';
	const cookies = document.cookie.split(';');

	for (let i = 0; i < cookies.length; i++) {
		let cookie = cookies[i];

		while (cookie.charAt(0) === ' ') {
			cookie = cookie.substring(1, cookie.length);
		}

		if (cookie.indexOf(prefix) === 0) {
			return cookie.substring(prefix.length, cookie.length);
		}
	}

	return null;
}

let hashClickLockout = false;

function initializeProductCards() {
	const cardLinks = document.querySelectorAll('.card_link');

	cardLinks.forEach(cardLink => {
		const hoverMedia = cardLink.querySelector('.hover_media');

		if (!hoverMedia) {
			return;
		}

		const mediaItems = hoverMedia.querySelectorAll('video, img:not(video > img)');

		let currentIndex = 0;
		let cycleInterval;
		const singleMedia = mediaItems.length <= 1;
		let touchStartX = 0;
		let touchEndX = 0;
		const swipeThreshold = 50;

		function showActiveMedia() {
			mediaItems.forEach(media => {
				media.classList.remove('active');

				if (media.tagName === 'VIDEO') {
					media.pause();
				}
			});

			mediaItems[currentIndex].classList.add('active');

			if (mediaItems[currentIndex].tagName === 'VIDEO') {
				mediaItems[currentIndex].play();
			}
		}

		function startCycle() {
			if (singleMedia) {
				mediaItems[0].classList.add('active');

				if (mediaItems[0].tagName === 'VIDEO') {
					mediaItems[0].play();
				}
			} else {
				showActiveMedia();
				cycleInterval = setInterval(() => {
					currentIndex = (currentIndex + 1) % mediaItems.length;
					showActiveMedia();
				}, 1000);
			}
		}

		function stopCycle() {
			clearInterval(cycleInterval);

			mediaItems.forEach(media => {
				media.classList.remove('active');

				if (media.tagName === 'VIDEO') {
					media.pause();
				}
			});

			currentIndex = 0;
		}

		function handleSwipe() {
			const diff = touchEndX - touchStartX;

			if (Math.abs(diff) > swipeThreshold) {
				if (diff > 0) {
					currentIndex = (currentIndex - 1 + mediaItems.length) % mediaItems.length;
				} else {
					currentIndex = (currentIndex + 1) % mediaItems.length;
				}

				clearInterval(cycleInterval);
				showActiveMedia();
				setTimeout(startCycle, 3000);
			}
		}

		hoverMedia.addEventListener('touchstart', e => {
			touchStartX = e.changedTouches[0].screenX;
		});
		hoverMedia.addEventListener('touchend', e => {
			touchEndX = e.changedTouches[0].screenX;
			handleSwipe();
		});
		cardLink.addEventListener('mouseenter', startCycle);
		cardLink.addEventListener('mouseleave', stopCycle);
	});
}

function getOrCreateModal() {
	let modal = document.getElementById('modal');
	let content = document.getElementById('modal_content');

	if (!modal) {
		modal = document.createElement('dialog');
		modal.id = 'modal';
		modal.tabIndex = -1;
		document.body.appendChild(modal);

		content = document.createElement('div');
		content.id = 'modal_content';
		modal.appendChild(content);

		const closeButton = document.createElement('button');
		closeButton.id = 'modal_close';
		closeButton.innerHTML = '<i class="fa-solid fa-xmark"></i>';
		modal.appendChild(closeButton);
	}

	return { modal, content };
}

// Slideout popups (left/right) keep the original plain-div implementation —
// see snippets/css.liquid for why this is a separate element from #modal.
function getOrCreateSlideoutModal() {
	let modal = document.getElementById('modal_slideout');
	let content = document.getElementById('modal_slideout_content');

	if (!modal) {
		modal = document.createElement('div');
		modal.id = 'modal_slideout';
		modal.style.display = 'none';
		modal.setAttribute('role', 'dialog');
		modal.setAttribute('aria-modal', 'true');
		modal.tabIndex = -1;
		document.body.appendChild(modal);

		content = document.createElement('div');
		content.id = 'modal_slideout_content';
		modal.appendChild(content);

		const closeButton = document.createElement('button');
		closeButton.id = 'modal_slideout_close';
		closeButton.innerHTML = '<i class="fa-solid fa-xmark"></i>';
		modal.appendChild(closeButton);
	}

	return { modal, content };
}

function initializePopups() {
	const popupSections = document.querySelectorAll('.section_popup_slide');
	const animatedElements = typeof elements !== 'undefined' ? elements : [];
	const { modal, content } = getOrCreateModal();
	const { modal: slideoutModal, content: slideoutContent } = getOrCreateSlideoutModal();

	function isSlideoutTrigger(triggerEl) {
		return triggerEl.classList.contains('type_left') || triggerEl.classList.contains('type_right');
	}

	// --- Center/fade popup — <dialog>-based ---

	function closeModal() {
		if (!modal || !content) {
			return;
		}

		const activeContent = content.querySelector('.modal_content');

		if (activeContent) {
			const dismissDays = parseInt(activeContent.getAttribute('data-dismiss')) || 0;
			const section = activeContent.closest('.shopify-section');
			const dismissId = section ? section.id : activeContent.getAttribute('data-id') || activeContent.id;

			if (dismissDays > 0) {
				setCookie('popupDismissed_' + dismissId, 'true', dismissDays);
			}
		}

		const modalContent = content.querySelector('.modal_content');

		if (modalContent) {
			modalContent.style.opacity = '0';
			modalContent.style.transform = 'scale(0.95)';
		}

		setTimeout(() => {
			modal.classList.remove('is_sliding');
			modal.close();
			document.body.classList.remove('modal_open');
			content.innerHTML = '';
		}, 500);
	}

	function openPopup(triggerEl, source = 'manual') {
		if (!modal || !content) {
			return;
		}

		const popupId = triggerEl.getAttribute('data-id') || triggerEl.id;
		const popupLabel = popupId ? `Popup ${popupId}` : 'Automatic popup';
		const dismissDays = parseInt(triggerEl.getAttribute('data-dismiss')) || 0;
		const section = triggerEl.closest('.shopify-section');
		const dismissId = section ? section.id : popupLabel;
		const cookieName = 'popupDismissed_' + dismissId;

		if (source !== 'click' && dismissDays > 0 && getCookie(cookieName)) {
			return false;
		}

		const popupClone = triggerEl.cloneNode(true);
		content.innerHTML = '';
		content.appendChild(popupClone);
		initializeProductCards();

		modal.classList.remove('is_sliding');

		if (!modal.open) {
			modal.showModal();
		}

		document.body.classList.add('modal_open');

		popupClone.style.opacity = '0';
		popupClone.style.transform = 'scale(0.95)';

		if (dismissDays > 0 && (source === 'scroll' || source === 'onload')) {
			setCookie(cookieName, 'true', dismissDays);
		}

		// Force a synchronous layout so the browser commits the closed state
		// before we flip to open (see getOrCreateSlideoutModal's comment for why
		// the slideout variant no longer relies on this alone).
		void modal.offsetHeight;

		requestAnimationFrame(() => {
			popupClone.style.opacity = '';
			popupClone.style.transform = '';
			modal.classList.add('is_sliding');
		});

		setTimeout(() => {
			animatedElements.forEach(el => {
				if (el.classList.contains('off_screen')) {
					el.classList.add('on_screen');
					el.classList.remove('off_screen');
				}
			});

			const offScreenInModal = content.querySelectorAll('.off_screen');
			offScreenInModal.forEach(el => {
				el.classList.add('on_screen');
				el.classList.remove('off_screen');
			});
		}, 1000);
	}

	// --- Slideout popup (left/right) — original plain-div implementation ---

	function closeSlideout() {
		if (!slideoutModal || !slideoutContent || slideoutModal.style.display !== 'flex') {
			return;
		}

		const activeContent = slideoutContent.querySelector('.modal_content');

		if (activeContent) {
			const dismissDays = parseInt(activeContent.getAttribute('data-dismiss')) || 0;
			const section = activeContent.closest('.shopify-section');
			const dismissId = section ? section.id : activeContent.getAttribute('data-id') || activeContent.id;

			if (dismissDays > 0) {
				setCookie('popupDismissed_' + dismissId, 'true', dismissDays);
			}
		}

		slideoutModal.classList.remove('is_sliding');

		setTimeout(() => {
			slideoutModal.style.display = 'none';
			document.body.classList.remove('modal_open');
			slideoutModal.classList.remove('slide-left', 'slide-right');
			slideoutContent.innerHTML = '';
		}, 500);
	}

	function openSlideout(triggerEl, source = 'manual') {
		if (!slideoutModal || !slideoutContent) {
			return;
		}

		const popupId = triggerEl.getAttribute('data-id') || triggerEl.id;
		const popupLabel = popupId ? `Popup ${popupId}` : 'Automatic popup';
		const dismissDays = parseInt(triggerEl.getAttribute('data-dismiss')) || 0;
		const section = triggerEl.closest('.shopify-section');
		const dismissId = section ? section.id : popupLabel;
		const cookieName = 'popupDismissed_' + dismissId;

		if (source !== 'click' && dismissDays > 0 && getCookie(cookieName)) {
			return false;
		}

		const popupClone = triggerEl.cloneNode(true);
		slideoutContent.innerHTML = '';
		slideoutContent.appendChild(popupClone);
		initializeProductCards();

		slideoutModal.classList.remove('slide-left', 'slide-right', 'is_sliding');

		if (triggerEl.classList.contains('type_left')) {
			slideoutModal.classList.add('slide-left');
		} else if (triggerEl.classList.contains('type_right')) {
			slideoutModal.classList.add('slide-right');
		}

		slideoutModal.style.display = 'flex';
		document.body.classList.add('modal_open');

		if (dismissDays > 0 && (source === 'scroll' || source === 'onload')) {
			setCookie(cookieName, 'true', dismissDays);
		}

		setTimeout(() => {
			slideoutModal.classList.add('is_sliding');
		}, 100);

		setTimeout(() => {
			animatedElements.forEach(el => {
				if (el.classList.contains('off_screen')) {
					el.classList.add('on_screen');
					el.classList.remove('off_screen');
				}
			});

			const offScreenInModal = slideoutContent.querySelectorAll('.off_screen');
			offScreenInModal.forEach(el => {
				el.classList.add('on_screen');
				el.classList.remove('off_screen');
			});
		}, 1000);
	}

	// --- Shared routing between the two ---

	function openPopupOrSlideout(triggerEl, source) {
		if (isSlideoutTrigger(triggerEl)) {
			openSlideout(triggerEl, source);
		} else {
			openPopup(triggerEl, source);
		}
	}

	function setupHashHandler() {
		if (window._hashHandlerAdded) {
			return;
		}

		window._hashHandlerAdded = true;

		document.addEventListener('click', function(e) {
			const link = e.target.closest('a[href^="#"]');

			if (!link) {
				return;
			}

			const href = link.getAttribute('href');

			if (!href || href.includes(':')) {
				return;
			}

			if (hashClickLockout) {
				return;
			}

			hashClickLockout = true;
			setTimeout(() => {
				hashClickLockout = false;
			}, 100);

			const target = document.querySelector(`.modal_content[data-id="${href}"]`) || document.getElementById(href.substring(1));

			if (target && target.closest('.section_popup_slide')) {
				e.preventDefault();

				if (isSlideoutTrigger(target)) {
					if (slideoutModal.style.display === 'flex') {
						closeSlideout();
						history.replaceState(null, null, ' ');
					} else {
						openSlideout(target, 'click');
					}
				} else if (modal.open) {
					closeModal();
					history.replaceState(null, null, ' ');
				} else {
					openPopup(target, 'click');
				}
			}
		});
	}

	modal.addEventListener('click', e => {
		if (e.target.id === 'modal' || e.target.closest('#modal_close')) {
			closeModal();
		}
	});

	// Intercept native Escape-close so the fade-out animation and
	// cookie-dismissal logic in closeModal() still run before it actually closes.
	modal.addEventListener('cancel', e => {
		e.preventDefault();
		closeModal();
	});

	slideoutModal.addEventListener('click', e => {
		if (e.target.id === 'modal_slideout' || e.target.closest('#modal_slideout_close')) {
			closeSlideout();
		}
	});

	document.addEventListener('keydown', e => {
		if (e.key === 'Escape' && slideoutModal.style.display === 'flex') {
			closeSlideout();
		}
	});

	setupHashHandler();

	document.addEventListener('popSlide', e => {
		const triggerId = e.detail.id;
		const triggerEl = document.querySelector(`.modal_content[data-id="${triggerId}"]`) || document.getElementById(triggerId);

		if (triggerEl && triggerEl.closest('.section_popup_slide')) {
			const section = triggerEl.closest('.section_popup_slide');

			if (section && scrollObserver) {
				scrollObserver.unobserve(section);
			}

			openPopupOrSlideout(triggerEl, 'event');
		}
	});

	const scrollObserver = typeof IntersectionObserver !== 'undefined' ? new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			const section = entry.target;
			const modalContent = section.querySelector('.modal_content');

			if (!modalContent) {
				return;
			}

			const popupId = modalContent.getAttribute('data-id') || modalContent.id;
			const popupLabel = popupId ? `Popup ${popupId}` : 'Automatic popup';

			if (entry.isIntersecting) {
				const scrollAttr = modalContent.getAttribute('data-scroll');
				const dismissDays = parseInt(modalContent.getAttribute('data-dismiss')) || 0;
				const shopifySection = modalContent.closest('.shopify-section');
				const dismissId = shopifySection ? shopifySection.id : popupLabel;
				const cookieName = 'popupDismissed_' + dismissId;

				if (scrollAttr === 'true') {
					if (dismissDays > 0 && getCookie(cookieName)) {
						observer.unobserve(section);
						return;
					}

					const triggerDelay = 1000 * parseInt(modalContent.getAttribute('data-trigger_delay')) || 0;
					observer.unobserve(section);
					setTimeout(() => {
						openPopupOrSlideout(modalContent, 'scroll');
					}, triggerDelay);
				}
			}
		});
	}, { threshold: 0.01 }) : null;

	popupSections.forEach(section => {
		const modalContent = section.querySelector('.modal_content');

		if (modalContent && modalContent.getAttribute('data-scroll') === 'true' && scrollObserver) {
			scrollObserver.observe(section);
		}
	});

	const hash = window.location.hash;

	if (hash && hash.length > 1) {
		const hashId = hash.substring(1);
		const targetEl = document.getElementById(hashId) || document.querySelector(`.modal_content[data-id="${hash}"]`);

		if (targetEl && targetEl.classList.contains('modal_content')) {
			const section = targetEl.closest('.section_popup_slide');

			if (section && scrollObserver) {
				scrollObserver.unobserve(section);
			}

			openPopupOrSlideout(targetEl, 'onload');
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	initializePopups();
	initializeProductCards();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["row"] && !Shopify.designMode) return;
  try {
    
	function onDOMReady(callback) {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', callback);
		} else {
			callback();
		}
	}
	function toggleVisibilityOnScroll() {
		const elements = document.querySelectorAll('.animate');

		if (elements.length === 0) {
			return;
		}

		function isInsidePreventAnimate(el) {
			return el.closest('.prevent_animate') !== null;
		}
		function isInViewport(el) {
			const rect = el.getBoundingClientRect();
			return (
				rect.top < window.innerHeight &&
				rect.bottom > 0 &&
				rect.left < window.innerWidth &&
				rect.right > 0
			);
		}
		function updateClasses() {
			elements.forEach(el => {
				if (isInsidePreventAnimate(el)) {
					el.classList.add('off_screen');
					el.classList.remove('on_screen');
				} else if (isInViewport(el)) {
					el.classList.add('on_screen');
					el.classList.remove('off_screen');
				} else {
					el.classList.add('off_screen');
					el.classList.remove('on_screen');
				}
			});
		}

		// rAF-throttled, not debounced -- caps the work to once per rendered frame
		// without waiting for scroll events to stop, so continuous touch-scroll
		// momentum still reveals elements in real time.
		let scheduled = false;
		function requestUpdate() {
			if (scheduled) {
				return;
			}
			scheduled = true;
			requestAnimationFrame(() => {
				scheduled = false;
				updateClasses();
			});
		}

		window.addEventListener('scroll', requestUpdate);
		window.addEventListener('resize', requestUpdate);
		document.addEventListener('DOMContentLoaded', updateClasses);
		window.addEventListener('active_animate', requestUpdate);
	}
	onDOMReady(() => {
		toggleVisibilityOnScroll();
	});
	document.addEventListener('input', (e) => { // restrict form input to specific characters
		const target = e.target;
		const restrict = target.getAttribute('data-restrict');
		if (restrict) {
			const start = target.selectionStart;
			const end = target.selectionEnd;
			const newValue = target.value.split('').filter(char => restrict.includes(char)).join('');
			if (target.value !== newValue) {
				target.value = newValue;
				target.setSelectionRange(start - 1, end - 1);
			}
		}
	});

  } catch(e) { console.error(e); }
})();
})();
